import { useEffect } from 'react';

import { VARIANT_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';
import { useFlexibleCampaignsUI } from '@/modules/flexibleCampaigns/useFlexibleCampaignsUI';

export function useFreeShippingMessagingExperiment(isEligible: boolean) {
  const isCampaignsUIActive = useFlexibleCampaignsUI();
  const isEligibleForMessaging = isEligible && !isCampaignsUIActive;

  const [decisions, bucket] = useExperiments(
    ['web_8765_free_shipping_messaging_us'],
    { deferred: true }
  );

  useEffect(() => {
    if (isEligibleForMessaging) {
      bucket();
    }
  }, [isEligibleForMessaging, bucket]);

  return (
    isEligibleForMessaging &&
    decisions.web_8765_free_shipping_messaging_us === VARIANT_IDENTIFIER
  );
}
